import { get, set, createStore, del, clear } from 'idb-keyval'

const pdfStore = createStore('pdf-cache-store', 'pdf-cache')

export const usePdfCache = () => {
  const getCachedPdf = (url: string): Promise<Blob | undefined> => {
    return get(url, pdfStore)
  }

  const setCachedPdf = (url: string, blob: Blob): Promise<void> => {
    return set(url, blob, pdfStore)
  }

  const deleteCachedPdf = (url: string): Promise<void> => {
    return del(url, pdfStore)
  }

  const clearCache = (): Promise<void> => {
    return clear(pdfStore)
  }

  return {
    getCachedPdf,
    setCachedPdf,
    deleteCachedPdf,
    clearCache,
  }
}
